import SearchIcon from "components/icons/SearchIcon";
import React, {useMemo, useState} from "react";
import MultiSelect from "@kenshooui/react-multi-select";
import {
    MdChevronRight,
    MdChevronLeft,
    MdCircle,
    MdCircleNotifications,
    MdConfirmationNumber,
    MdEdit, MdOutlineSave, MdOutlineCancel, MdFileDownload, MdPerson, MdDownload
} from "react-icons/md";
import {
    useGlobalFilter,
    usePagination,
    useSortBy,
    useTable,
} from "react-table";
import {DiAndroid, DiApple} from "react-icons/di";
import {utils, writeFile} from "xlsx";
import {NumberInput} from "@chakra-ui/react";
import avatar from "assets/img/profile/Subtractprofile white.png";
import axios from "axios";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import moment from "moment/moment";
import useAsyncEffect from "use-async-effect";
import NftCard from "../../../../components/card/NftCard";
import avatar1 from "../../../../assets/img/avatars/avatar1.png";
import avatar2 from "../../../../assets/img/avatars/avatar2.png";
import avatar3 from "../../../../assets/img/avatars/avatar3.png";

function UsersOverView(props) {
    const {columnsData, tableData} = props;

    const columns = useMemo(() => columnsData, [columnsData]);

    //const data = useMemo(() => tableData, [tableData]);

    let [data, setData] = useState(tableData);

    const tableInstance = useTable(
        {
            columns,
            data,
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,

        prepareRow,
        nextPage,
        previousPage,
        setPageSize,

        setGlobalFilter,
        state,
    } = tableInstance;

    const {pageSize} = state;
    const currentPage = state.pageIndex; // Page index starts from 0
    const totalPages = Math.ceil(data.length / pageSize);

    let [userEditable, setUserEditable] = useState(false);
    let [isLoading, setIsLoading] = useState(false)

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    const secretKey = "cromptonssecretkey";
    let [selectedValue, setSelectedValue] = useState("100")
    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);

    //console.log(state.globalFilter)
    function convertGMTtoIST(gmtDateTime) {
        // Create a new Date object with the GMT date and time
        const gmtDate = new Date(gmtDateTime);

        // Get the time zone offset for IST
        const istOffset = gmtDate.getTimezoneOffset() + 330; // IST is UTC+5:30

        // Create a new Date object with the IST date and time
        const istDate = new Date(gmtDate.getTime() + istOffset);

        // Return the IST date and time in DD/MM/YYYY HH:MM format
        return istDate.toLocaleString('en-IN', {timeZone: 'Asia/Kolkata'});
    }

    function getCurrentDate() {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Jan is 0!
        const year = today.getFullYear();

        return `${day}-${month}-${year}`
    }

    function exportProductData() {
        let filteredData

        filteredData = data.map((item) => ({
            ProductName: item.product,
            PID: item.productId,
            Unit: item.unit,
            Category: item.category,
            CreatedTime: convertGMTtoIST(item.createdTime),
            LastModified: convertGMTtoIST(item.lastModified)
        }));

        let wb = utils.book_new(),
            ws = utils.json_to_sheet(filteredData);
        utils.book_append_sheet(wb, ws, "crompton_product_details")
        writeFile(wb, "crompton_product_details" + getCurrentDate() + ".xlsx")
    }

    function handleSearchFilter(searchTerm) {
        // console.log(searchTerm)
        // console.log(data)
        setData(tableData)
        data = tableData
        if (searchTerm.length > 0) {
            let filterData = data.filter((c) => {
                // Search across multiple properties
                return (c.product && c.product.includes(searchTerm)) ||
                    (c.productId && c.productId.includes(searchTerm)) ||
                    (c.category && c.category.includes(searchTerm)) ||
                    (c.unit && c.unit.includes(searchTerm))
                // ... add more properties as needed

            });
            //console.log(filterData)
            setData(filterData)
            data = filterData
        } else {
            setData(tableData)
        }

    }

    function handleSearchFilterForActiveInactive(searchTerm) {
        //console.log(searchTerm)
        // console.log(data)
        setData(tableData)
        data = tableData
        let filterData = data.filter((c) => {
            // Search across multiple properties
            return (c.def.toString() === searchTerm)
            // ... add more properties as needed

        });
       // console.log(filterData)
        setData(filterData)
        data = filterData


    }

    function handleChangeProductFilter() {
        const selectBox = document.getElementById("productFilterSelectBox")
        selectedValue = selectBox.options[selectBox.selectedIndex].value
        setSelectedValue(selectBox.options[selectBox.selectedIndex].value)
        //console.log(selectedValue)
        setGlobalFilter(selectedValue)
        handleSearchFilter(selectedValue)
        //getRegisteredUsersTrend(selectedValue)
    }

    function handleProductActiveInactiveFilter() {
        const selectBox = document.getElementById("productActiveFilter")
        selectedValue = selectBox.options[selectBox.selectedIndex].value
        setSelectedValue(selectBox.options[selectBox.selectedIndex].value)
        //console.log(selectedValue)
        setGlobalFilter(selectedValue)
        handleSearchFilterForActiveInactive(selectedValue)
        //getRegisteredUsersTrend(selectedValue)
    }

    var sv = "";

    const navigate = useNavigate();

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    return (
        <div className="h-full w-full">

            {/* Search */}
            <div className="mx-auto mt-5 flex w-full gap-1 overflow-hidden md:!gap-6 xl:w-[96%]">
                <div
                    className="flex h-[45px] w-full rounded-xl border !border-gray-200 dark:!border-none dark:!bg-navy-700 md:w-[870px] xl:w-full"
                    onChange={(e) => handleSearchFilter(e.target.value)}>
                    <SearchIcon className="dark:text-white"/>
                    <input
                        placeholder="Search..."
                        className="!w-full rounded-xl text-sm font-medium outline-none dark:bg-navy-700 dark:text-white sm:w-[50px] xl:!w-full"
                        type="text"
                    />
                </div>
                <div
                    className="w-full rounded-xl border !border-gray-200 px-3 text-sm font-medium text-gray-600 outline-none dark:!border-none dark:bg-navy-700 md:w-fit">
                    <select
                        className="h-[45px] w-full rounded-xl text-sm font-medium text-gray-600 outline-none dark:bg-navy-700 md:w-fit md:pr-8 xl:pr-20"
                        name=""
                        id="productFilterSelectBox" onChange={handleChangeProductFilter}>
                        <option value="">All</option>
                        <option value="Fan">Fans</option>
                        <option value="Appliances">Appliances</option>
                        <option value="Lighting">Lighting</option>
                        <option value="Pumps">Pumps</option>
                    </select>
                </div>
                <div
                    className="w-full rounded-xl border !border-gray-200 px-3 text-sm font-medium text-gray-600 outline-none dark:!border-none dark:bg-navy-700 md:w-fit">
                    <select
                        className="h-[45px] w-full rounded-xl text-sm font-medium text-gray-600 outline-none dark:bg-navy-700 md:w-fit md:pr-8 xl:pr-20"
                        name=""
                        id="productActiveFilter" onChange={handleProductActiveInactiveFilter}>
                        <option value="">All</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                    </select>
                </div>
                <button className="flex items-center justify-center rounded-xl border
                !border-gray-200 p-3 text-navy-700 transition duration-200 hover:cursor-pointer
                hover:bg-gray-100 active:bg-gray-50 dark:!border-none dark:bg-navy-700 dark:text-white
                dark:hover:bg-white/20 dark:active:bg-white/10" onClick={exportProductData}>
                    <MdDownload/>
                    Export
                </button>
            </div>

            <div className='w-full h-full mt-3 p-4'>
                <div className="col-span-1 h-fit w-full xl:col-span-1 2xl:col-span-2">

                    {/* NFTs trending card */}
                    <div
                        className="z-20 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-4 3xl:grid-cols-4">
                        {
                            data.map((Val) => {
                                    return (
                                        <NftCard
                                            bidders={[avatar1, avatar2, avatar3]}
                                            title={Val.product}
                                            productCategory={Val.unit}
                                            productSubCategory={Val.category}
                                            productId={Val.productId}
                                            image={Val.productUrl === "" ? (Val.categoryEnUrl === "" ? "https://iot.crompton.co.in/CDN/img/catalog/catagory/ic_cat_grey_appliances.png" : Val.categoryEnUrl) : Val.productUrl}
                                            createdTime={convertGMTtoIST(Val.createdTime)}
                                            lastModified={convertGMTtoIST(Val.lastModified)}
                                            mfg={Val.mfg}
                                            def={Val.def}
                                        />
                                    )
                                }
                            )
                        }
                    </div>

                </div>

                {/* right side section */}
            </div>

            {/* pagination */}
            {/*<div className=" mt-2 flex h-20 w-full items-center justify-between px-6">
                 left side
                <div className=" flex items-center gap-3">
                    <p className="> Show rows per page text-sm text-gray-700 font-bold dark:text-white">
                        Show rows per page{" "}
                    </p>
                    <select
                        value={pageSize}
                        onChange={(e) => setPageSize(Number(e.target.value))}
                        className="h-[32px] w-[75px] rounded-[20px] border border-gray-700 px-2 text-gray-700 font-bold dark:!border-white/10 dark:bg-navy-800 dark:text-white"
                        name=""
                        id=""
                    >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
                <div className="flex items-center gap-4">
                    <p className="text-sm font-bold text-gray-700 dark:text-white">
                        Page {currentPage + 1} of {totalPages}
                    </p>
                </div>
                 right side
                <div className="flex items-center gap-3">
                    {state.pageIndex !== 0 && (
                        <button
                            onClick={previousPage}
                            disabled={state.pageIndex === 0}
                            className={`linear flex items-center justify-center rounded-full bg-[#004c86] p-2 text-lg text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86] `}
                        >
                            <MdChevronLeft/>
                        </button>
                    )}
                    <p className="text-sm text-gray-700 font-bold dark:text-white ">
                        {currentPage + 1}
                    </p>
                    {state.pageIndex !== totalPages - 1 && (
                        <button
                            onClick={nextPage}
                            disabled={state.pageIndex === totalPages}
                            className={`linear flex items-center justify-center rounded-full bg-[#004c86] p-2 text-lg text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86] `}
                        >
                            <MdChevronRight/>
                        </button>
                    )}
                </div>
            </div>*/}
        </div>
    )
        ;
}

export default UsersOverView;

